import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useAuthStore } from './stores/authStore';
import { Layout } from './components/layout/Layout';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { Users } from './pages/Users';
import { Chats, ChatDetail } from './pages/Chats';
import { Feedback } from './pages/Feedback';
import { Notifications } from './pages/Notifications';
import { TrafficSources } from './pages/TrafficSources';
import { Images } from './pages/Images';
import { Recommendations } from './pages/Recommendations';
import { ModelSettings } from './pages/ModelSettings';
import { GroupSubscriptions } from './pages/GroupSubscriptions';

// Компонент защищённого роута
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading, init } = useAuthStore();
  const location = useLocation();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      await init();
      setIsChecking(false);
    };
    checkAuth();
  }, []);

  if (isLoading || isChecking) {
    return (
      <div className="min-h-screen bg-bg-primary flex items-center justify-center">
        <div className="animate-spin h-8 w-8 border-2 border-accent-primary border-t-transparent rounded-full" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Layout>{children}</Layout>;
};

// Компонент для публичных роутов (login)
const PublicRoute = ({ children }) => {
  const { isAuthenticated, isLoading, init } = useAuthStore();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      await init();
      setIsChecking(false);
    };
    checkAuth();
  }, []);

  if (isLoading || isChecking) {
    return (
      <div className="min-h-screen bg-bg-primary flex items-center justify-center">
        <div className="animate-spin h-8 w-8 border-2 border-accent-primary border-t-transparent rounded-full" />
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
};

function AppRoutes() {
  return (
    <Routes>
      {/* Публичные роуты */}
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />

      {/* Защищённые роуты */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/users"
        element={
          <ProtectedRoute>
            <Users />
          </ProtectedRoute>
        }
      />
      <Route
        path="/chats"
        element={
          <ProtectedRoute>
            <Chats />
          </ProtectedRoute>
        }
      />
      <Route
        path="/chats/:id"
        element={
          <ProtectedRoute>
            <ChatDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path="/feedback"
        element={
          <ProtectedRoute>
            <Feedback />
          </ProtectedRoute>
        }
      />
      <Route
        path="/notifications"
        element={
          <ProtectedRoute>
            <Notifications />
          </ProtectedRoute>
        }
      />
      <Route
        path="/traffic-sources"
        element={
          <ProtectedRoute>
            <TrafficSources />
          </ProtectedRoute>
        }
      />
      <Route
        path="/images"
        element={
          <ProtectedRoute>
            <Images />
          </ProtectedRoute>
        }
      />
      <Route
        path="/recommendations"
        element={
          <ProtectedRoute>
            <Recommendations />
          </ProtectedRoute>
        }
      />
      <Route
        path="/model-settings"
        element={
          <ProtectedRoute>
            <ModelSettings />
          </ProtectedRoute>
        }
      />
      <Route
        path="/group-subscriptions"
        element={
          <ProtectedRoute>
            <GroupSubscriptions />
          </ProtectedRoute>
        }
      />

      {/* Redirect unknown routes */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
